export const isClient = () => typeof window !== "undefined";

export const getLocalStorageItem = (key: string) => {
  if (isClient()) {
    return localStorage.getItem(key);
  }
  return null;
};

export const setLocalStorageItem = (key: string, value: string) => {
  if (isClient()) {
    localStorage.setItem(key, value);
  }
};

export const removeLocalStorageItem = (key: string) => {
  if (isClient()) {
    localStorage.removeItem(key);
  }
};
